<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <q-form ref="editForm">
          <c-card title="LBLBASEINFO" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveInfo"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
                <div class="col-2">
                  <c-text
                    :required="true"
                    :editable="editable"
                    label="배출구명"
                    name="envAirMstOutletNm"
                    v-model="data.envAirMstOutletNm">
                  </c-text>
                </div>
                <div class="col-2">
                  <c-text
                    :required="true"
                    :editable="editable"
                    label="허가증상 일련번호"
                    name="envAirMstOutletSems"
                    v-model="data.envAirMstOutletSems">
                  </c-text>
                </div>
                <div class="col-2">
                  <c-text
                    :required="true"
                    :editable="editable"
                    label="배출구 일련번호"
                    name="envAirMstOutletName"
                    v-model="data.envAirMstOutletName">
                  </c-text>
                </div>
                <!-- <div class="col-3">
                  <c-text
                    :editable="editable"
                    label="LBLLOCATION"
                    name="location"
                    v-model="data.location">
                  </c-text>
                </div>
                <div class="col-2">
                  <c-text
                    suffix="㎥/분"
                    type="number"
                    :required="true"
                    :editable="editable"
                    label="처리용량"
                    name="handlingCapacity"
                    v-model="data.handlingCapacity">
                  </c-text>
                </div>
                <div class="col-2">
                  <c-text
                    suffix="㎥/분"
                    type="number"
                    :editable="editable"
                    label="설계(허가증)용량"
                    name="permitCapacity"
                    v-model="data.permitCapacity">
                  </c-text>
                </div> -->
                <div class="col-2">
                  <c-plant :required="true" :editable="editable" type="edit" name="plantCd" v-model="data.plantCd" />
                </div>
                <div class="col-2">
                  <c-text
                    :editable="editable"
                    label="배출구종수"
                    name="outletWidth"
                    v-model="data.outletWidth">
                  </c-text>
                </div>
                <div class="col-2">
                  <c-text
                    :editable="editable"
                    label="법정측정횟수"
                    name="outletHeight"
                    v-model="data.outletHeight">
                  </c-text>
                </div>
                <div class="col-2">
                  <c-dept type="edit" :editable="editable" label="관리부서" name="deptCd" v-model="data.deptCd" />
                </div>
                <div class="col-2">
                  <c-checkbox
                    :editable="editable"
                    :isFlag="true"
                    label="LBLUSEFLAG"
                    name="useFlag"
                    v-model="data.useFlag"
                  />
                </div>
                <div class="col-2">
                  <c-checkbox
                    :editable="editable"
                    :isFlag="true"
                    label="방지시설면제여부"
                    name="preventExemptionFlag"
                    v-model="data.preventExemptionFlag"
                    @input="changePrevent"
                  />
                </div>
                <!-- <div class="col-2">
                  <c-air-preventive
                    :editable="data.preventExemptionFlag == 'N'"
                    label="연결방지시설"
                    name="envAirMstPreventiveId"
                    v-model="data.envAirMstPreventiveId">
                  </c-air-preventive>
                </div> -->
            </template>
          </c-card>
        </q-form>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" v-show="popupParam.envAirMstOutletId">
        <c-table
          ref="grid"
          title="자가측정 검사항목"
          tableId="grid"
          :columns="grid.columns"
          :data="grid.data"
          :usePaging="false"
          :hideBottom="true"
          :columnSetting="false"
          :isFullScreen="false"
          :filtering="false"
          :isExcelDown="false"
          gridHeight="500px"
          selection="multiple"
          rowKey="envAirPlantInspectItemId"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="LBLSAVE" v-if="editable && popupParam.envAirMstOutletId" icon="save" @btnClicked="saverow1" />
              <c-btn label="LBLADD" v-if="editable && popupParam.envAirMstOutletId" icon="add" @btnClicked="addrow1" />
              <c-btn label="LBLREMOVE" v-if="editable && popupParam.envAirMstOutletId" icon="remove" @btnClicked="removeRow1" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" v-show="popupParam.envAirMstOutletId">
        <c-table
          ref="grid2"
          title="배출구별 방지시설/배출시설"
          tableId="grid2"
          :columns="grid2.columns"
          :data="grid2.data"
          :merge="grid2.merge"
          :usePaging="false"
          :hideBottom="true"
          :columnSetting="false"
          :isFullScreen="false"
          :filtering="false"
          :isExcelDown="false"
          gridHeight="500px"
          selection="multiple"
          :editable="editable"
          rowKey="envAirMstPreventiveId"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="방지시설추가" v-if="editable && popupParam.envAirMstOutletId" icon="add" @btnClicked="addrow2" />
              <c-btn label="방지시설삭제" v-if="editable && popupParam.envAirMstOutletId" icon="remove" @btnClicked="removeRow2" />
              <c-btn label="차수저장" v-if="editable && popupParam.envAirMstOutletId" icon="save" @btnClicked="saveRow2" />
            </q-btn-group>
          </template>
        </c-table>
      </div> 
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'water-master03-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          envAirMstOutletId: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      data: {
        plantCd: null,  // 사업장코드
        envAirMstOutletId: '',  // 대기배출구 시스템 일련번호
        envAirMstOutletNm: '', // 배출구명
        envAirMstOutletName: '',  // 배출구일련번호
        envAirMstOutletSems: '', // 허가증상 일련번호
        location: '',  // 위치
        handlingCapacity: '',  // 방지시설처리용량
        permitCapacity: '',  // 방지시설처리용량
        outletWidth: '',  // 직경
        outletHeight: '',  // 높이
        deptCd: '',  // 관리부서 코드
        useFlag: 'Y',  // 사용여부
        envAirMstPreventiveId: '', // 언결방지시설
        preventExemptionFlag: 'N', // 방지시설면제여부
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '50%',
        top: '',
        param: {},
        closeCallback: null,
      },
      itemListUrl: '',
      itemInsertUrl: '',
      itemDeleteUrl: '',
      disListUrl: '',
      predisListUrl: '',
      disInsertUrl: '',
      disDeleteUrl: '',
      saveUrl: transactionConfig.env.air.mst.outlet.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      editable: true,
      isSave: false,
      updateMode: false,
      grid: {
        columns: [
          // {
          //   name: 'airInspectTypeName',
          //   field: 'airInspectTypeName',
          //   label: '검사구분',
          //   align: 'center',
          //   sortable: true,
          // },
          {
            name: 'envAirMstInspectItemName',
            field: 'envAirMstInspectItemName',
            label: '검사항목',
            align: 'center',
            sortable: true,
          },
          {
            name: 'airInspectUnitName',
            field: 'airInspectUnitName',
            label: 'LBLUNIT',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'legalStandard',
            field: 'legalStandard',
            label: '법적기준',
            align: 'center',
            type: 'number',
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: 'innerStandard',
            field: 'innerStandard',
            label: '내부기준',
            align: 'center',
            type: 'number',
            style: 'width: 120px',
            sortable: true,
          },
        ],
        data: [],
      },
      grid2: {
        merge: [
          { index: 0, colName: 'envAirMstPreventiveId' },
          { index: 1, colName: 'envAirMstPreventiveId' },
          { index: 2, colName: 'envAirMstPreventiveId' },
          { index: 3, colName: 'envAirMstPreventiveId' },
          { index: 4, colName: 'envAirMstPreventiveId' },
        ],
          columns: [
          {
            name: 'x1',
            field: 'x1',
            label: '연결 방지시설',
            align: 'center',
            child: [
              {
                name: 'sortOrder',
                field: 'sortOrder',
                label: '연결차수',
                align: 'center',
                type: 'number',
                style: 'width: 70px',
                sortable: false,
              },
              {
                name: 'envAirMstPreventiveName',
                field: 'envAirMstPreventiveName',
                label: '방지시설명',
                align: 'left',
                sortable: false,
              },
              {
                name: 'envAirMstPreventiveNo',
                field: 'envAirMstPreventiveNo',
                label: '일련번호',
                align: 'center',
                style: 'width: 70px',
                sortable: false,
              },
              {
                name: 'envAirMstPreventiveNum',
                field: 'envAirMstPreventiveNum',
                label: '사내고유일련번호',
                align: 'center',
                style: 'width: 120px',
                sortable: false,
              },
              {
                name: 'location',
                field: 'location',
                label: 'LBLLOCATION',
                align: 'center',
                style: 'width: 120px',
                sortable: false,
              },
            ]
          },
          {
            name: 'x2',
            field: 'x2',
            label: '연결 배출시설',
            align: 'center',
            child: [
              {
                name: 'envAirMstDischargeName',
                field: 'envAirMstDischargeName',
                label: '배출시설명',
                align: 'left',
                sortable: false,
              },
              {
                name: 'envAirMstDischargeNo',
                field: 'envAirMstDischargeNo',
                label: '관리번호',
                align: 'center',
                style: 'width: 70px',
                sortable: false,
              },
              {
                name: 'handlingCapacity',
                field: 'handlingCapacity',
                label: '시설용량',
                align: 'right',
                type: 'cost',
                style: 'width: 70px',
                sortable: false,
              },
            ]
          },
        ],
        data: [],
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.detailUrl = selectConfig.env.air.mst.outlet.get.url;
      this.saveUrl = transactionConfig.env.air.mst.outlet.insert.url;
      this.itemListUrl = selectConfig.env.air.mst.outlet.inspect.url;
      this.itemInsertUrl = transactionConfig.env.air.mst.outlet.inspect.save.url;
      this.itemDeleteUrl = transactionConfig.env.air.mst.outlet.inspect.delete.url;
      this.disListUrl = selectConfig.env.air.mst.outlet.preventive.url;
      this.disInsertUrl = transactionConfig.env.air.mst.outlet.preventive.save.url;
      this.disDeleteUrl = transactionConfig.env.air.mst.outlet.preventive.delete.url;
      this.predisListUrl = selectConfig.env.air.mst.outlet.dispre.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.envAirMstOutletId) {
        this.$http.url = this.detailUrl;
        this.$http.param = {envAirMstOutletId: this.popupParam.envAirMstOutletId}
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          this.updateMode = true;
          this.getItemList();
          this.getDisList();
        },);
      }
    },
    getItemList() {
      if (this.popupParam.envAirMstOutletId) {
        this.$http.url = this.itemListUrl;
        this.$http.param = {envAirMstOutletId: this.popupParam.envAirMstOutletId}
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      }
    },
    getDisList() {
      if (this.popupParam.envAirMstOutletId) {
        this.$http.url = this.predisListUrl;
        this.$http.param = {envAirMstOutletId: this.popupParam.envAirMstOutletId}
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid2.data = _result.data;
        },);
      }
    },
    saveInfo() {
      if (this.popupParam.envAirMstOutletId) {
        this.saveUrl = transactionConfig.env.air.mst.outlet.update.url;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.env.air.mst.outlet.insert.url;
        this.mappingType = 'POST';
      }

      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      this.popupParam.envAirMstOutletId = result.data.envAirMstOutletId;
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.mappingType == 'POST') {
        this.$emit('insertOutletInfo', result.data.envAirMstOutletId);
      }
      this.getDetail();
    },
    saverow1() {
      this.$http.url = this.itemInsertUrl;
      this.$http.type = 'POST';
      this.$http.param = this.grid.data;
      this.$http.request(() => {
        this.getItemList();
      });
    },
    addrow1() {
      this.popupOptions.title = '대기 검사항목';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.data.plantCd
      };
      this.popupOptions.target = () => import(`${'./inspectItemPlantPop.vue'}`);
      this.popupOptions.width = '50%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup1;
    },
    closePopup1(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid.data, { envAirMstInspectItemId: item.envAirMstInspectItemId }) === -1) {
            saveData.push({
              envAirPlantInspectItemId: item.envAirPlantInspectItemId,  // 사업장별 대기 검사항목 일련번호
              envAirMstOutletId: this.popupParam.envAirMstOutletId,  // 대기배출구(방지시설) 일련번호
              envAirMstInspectItemId: item.envAirMstInspectItemId,
              airInspectTypeName: item.airInspectTypeName,
              envAirMstInspectItemName: item.envAirMstInspectItemName,
              airInspectUnitName: item.airInspectUnitName,
              legalStandard: item.legalStandard,
              innerStandard: item.innerStandard,
              editFlag: 'C',
              regUserId: this.$store.getters.user.userId,
              chgUserId: this.$store.getters.user.userId,
            });
          }
        });
        this.$http.url = this.itemInsertUrl;
        this.$http.type = 'POST';
        this.$http.param = saveData;
        this.$http.request(() => {
          this.getItemList();
        });
      }
    },
    removeRow1() {
      let selectData = this.$refs['grid'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.itemDeleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.grid.data = this.$_.reject(this.grid.data, item);
              })
              this.$refs['grid'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addrow2() {
      this.popupOptions.title = '대기 방지시설';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.data.plantCd
      };
      this.popupOptions.target = () => import(`${'@/pages/common/air/preventivePop.vue'}`);
      this.popupOptions.width = '50%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup2;
    },
    closePopup2(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid2.data, { envAirMstPreventiveId: item.envAirMstPreventiveId }) === -1) {
            saveData.push({
              plantCd: item.plantCd,  // 사업장별 대기 검사항목 일련번호
              envAirMstOutletId: this.popupParam.envAirMstOutletId,
              envAirMstPreventiveId: item.envAirMstPreventiveId,
              editFlag: 'C',
              regUserId: this.$store.getters.user.userId,
              chgUserId: this.$store.getters.user.userId,
            });
          }
        });
        this.$http.url = this.disInsertUrl;
        this.$http.type = 'POST';
        this.$http.param = saveData;
        this.$http.request(() => {
          this.getDisList();
        });
      }
    },
    removeRow2() {
      let selectData = this.$refs['grid2'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.disDeleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.getDisList();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveRow2() {
      let saveData = this.grid2.data.filter( x => {
        return x.editFlag == 'U'
      });
      this.$_.forEach(saveData, item => {
        item.regUserId = this.$store.getters.user.userId;
        item.chgUserId = this.$store.getters.user.userId;
      });
      if(saveData.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.disInsertUrl;
            this.$http.type = 'PUT';
            this.$http.param = saveData;
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.getDisList();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: 'MSGNOCHANGEDATA', // 변경된 데이터가 없습니다., /* 변경된 데이터가 없습니다. */
          type: 'info', // success / info / warning / error
        });
      }
    },
    changePrevent() {
      if (this.data.preventExemptionFlag == 'Y') {
        this.data.envAirMstPreventiveId = '';
      }
    }
  }
};
</script>